





























































/* api */
import GetImageApi from '@/app/model/api/getImageApi'
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component
export default class FieldImg extends Vue {
  private showImgModal: boolean = false;
  private noImgPath: string = require('@/assets/img/no_image.svg')
  private originalImagePath: string = ''
  private displayImg: string = ''

  @Prop() private plantingId!: number
  @Prop() private images!: any
  @Prop() private displayNumber!: string

  @Watch('images')
  onChangeImgData (data: any) {
    this.getDefaultImg()
  }

  created () {
    this.getDefaultImg()
  }

  private imageData: any = {}

  private async getDefaultImg () {
    for (let i in this.images) {
      if (this.images[i].display_number === this.displayNumber) {
        if (this.plantingId !== 0) {
          let date = new Date(this.images[i].image_record_date)
          let body: any = {
            planting_id: this.plantingId,
            date: '' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate()),
            type: '',
            crop_image_id: this.images[i].crop_image_id
          }

          const result = await GetImageApi.getImageData(body)
          if (typeof result === 'string') {
            this.displayImg = String(result)
          } else {
            this.displayImg = ''
          }
          this.imageData = {
            date: body.date,
            crop_image_id: body.crop_image_id
          }
          return
        }
      }
    }
    this.displayImg = this.noImgPath
    this.imageData = {
      date: '',
      crop_image_id: null
    }
  }

  /* モーダルのオリジナル画像を取得 */
  private async showModal () {
    if (this.imageData.date !== '' && this.imageData.crop_image_id !== null) {
      if (this.plantingId !== 0) {
        let body: any = {
          planting_id: this.plantingId,
          date: this.imageData.date,
          type: 'original',
          crop_image_id: this.imageData.crop_image_id
        }

        const result = await GetImageApi.getImageData(body)
        if (typeof result === 'string') {
          this.originalImagePath = String(result)
        } else {
          this.originalImagePath = ''
        }
        this.showImgModal = true
        return
      }
    }

    this.originalImagePath = this.noImgPath
    this.showImgModal = true
  }
}
